import qs from 'qs';
import contentService from '../../services/contentService';
import {
  FETCH_OFFERS_CLEAN_UP,
  FETCH_OFFERS_FAILURE,
  FETCH_OFFERS_FOR_PAGE_CLEAN_UP,
  FETCH_OFFERS_REQUEST,
  FETCH_OFFERS_SUCCESS,
  UPDATE_OFFERS_PAGE_START_PARAM,
} from '../constants/offersTypes';

const fetchOffersRequest = () => ({ type: FETCH_OFFERS_REQUEST });

const fetchOffersSuccess = (payload) => ({
  type: FETCH_OFFERS_SUCCESS,
  payload,
});

const fetchOffersFailure = (error) => ({
  type: FETCH_OFFERS_FAILURE,
  payload: error,
});

export const fetchOffersCleanUp = () => ({
  type: FETCH_OFFERS_CLEAN_UP,
});

export const fetchOffersForPageCleanUp = () => ({
  type: FETCH_OFFERS_FOR_PAGE_CLEAN_UP,
});

export const updateOffersPageStartParam = (increment = 6) => ({
  type: UPDATE_OFFERS_PAGE_START_PARAM,
  payload: increment,
});

export const fetchOffers = ({
  categories = [],
  city,
  start,
  limit,
  locale = 'de',
} = {}) => {
  return (dispatch) => {
    const categoriesList = categories.map((item) => item.id);
    const query = qs.stringify(
      { _where: { 'categories.id': categoriesList } },
      { encode: false, arrayFormat: 'repeat' }
    );

    const contentsQuery = `sort=publishAt%3Adesc&filters[type][$eq]=offer&populate[main_image]=true${
      categories.length > 0 ? `&${query}` : ''
    }${city ? `&filters[city][$eq]=${city}` : ''}${
      start ? `&pagination[start]=${start}` : ''
    }${limit ? `&pagination[limit]=${limit}` : ''}`;

    dispatch(fetchOffersRequest());
    contentService
      .getContents(contentsQuery, locale)
      .then((response) => {
        const offers = response.data;
        dispatch(fetchOffersSuccess({ offers, limit }));
      })
      .catch((error) => {
        dispatch(fetchOffersFailure(error.message));
      });
  };
};

export const fetchOffersForPage = ({
  categories = [],
  city = undefined,
  start = 0, // Offset for pagination
  limit = 6, // Number of items to fetch
  locale = 'de',
} = {}) => {
  return async (dispatch) => {
    // Build query string
    const categoriesList = categories.map((item) => item.id);
    const query = qs.stringify(
      {
        _where: { 'categories.id': categoriesList },
      },
      { encode: false, arrayFormat: 'repeat' }
    );

    // Construct query
    const contentsQuery = `sort=publishAt:desc,id:asc&filters[type][$eq]=offer&populate[main_image]=true${
      categories.length > 0 ? `&${query}` : ''
    }${
      city ? `&filters[city][$eq]=${city}` : ''
    }&pagination[start]=${start}&pagination[limit]=${limit}`;

    try {
      const offers = await contentService.getContents(contentsQuery, locale);
      return offers;
    } catch (error) {
      return null;
    }
  };
};
